import type { IconSvgObject } from './types';

const FileFavouriteIcon: IconSvgObject = [
  ["path", { d: "M15 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.7431 2.28961C9.14648 1.45704 8.00003 2.68433 8.00003 2.68433C8.00003 2.68433 6.85353 1.45704 5.25685 2.2896C3.32296 3.298 3.18408 7.24692 8.00003 9C12.816 7.24692 12.677 3.298 10.7431 2.28961Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileFavouriteIcon;
